import { Outlet, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import ScrollToTopButton from '@/components/feature/ScrollToTopButton';
import { ToastProvider } from '@/components/base/ToastProvider';

export default function SiteLayout() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <ToastProvider>
      <div className="flex min-h-screen w-full flex-col bg-background-100">
        <SiteHeader />
        <main className={`w-full flex-1 ${isHome ? '' : 'pt-16'}`}>
          <Outlet />
        </main>
        <SiteFooter />
        <ScrollToTopButton />
      </div>
    </ToastProvider>
  );
}